export { resolveAddress } from '@src/features/address/queries/resolveAddress';
